import { render, staticRenderFns } from "./classification-unit-add.vue?vue&type=template&id=51efd934&scoped=true"
import script from "./classification-unit-add.vue?vue&type=script&lang=js"
export * from "./classification-unit-add.vue?vue&type=script&lang=js"
import style0 from "./classification-unit-add.vue?vue&type=style&index=0&id=51efd934&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51efd934",
  null
  
)

export default component.exports